function GreenRetangle({ className }) {
  return (
    <svg
      className={className}
      width="375"
      height="382"
      border-radius="6"
      viewBox="0 0 405 386"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="405" height="386" rx="6" fill="#154734" />
    </svg>
  );
}

export default GreenRetangle;
